export const SET_HRESS3U_INDEX_DISP = 'SET_HRESS3U_INDEX_DISP'
export const GET_HRESS3U_INDEX_DISP = 'GET_HRESS3U_INDEX_DISP'
export const SET_HRESS3U_DETAIL_DISP = 'SET_HRESS3U_DETAIL_DISP'
export const GET_HRESS3U_DETAIL_DISP = 'GET_HRESS3U_DETAIL_DISP'
export const SET_HRESS3U_MAX_ROWSPAN = 'SET_HRESS3U_MAX_ROWSPAN'
export const GET_HRESS3U_MAX_ROWSPAN = 'GET_HRESS3U_MAX_ROWSPAN'
export const SET_HRESS3U_COLUMNS = 'SET_HRESS3U_COLUMNS'
export const GET_HRESS3U_COLUMNS = 'GET_HRESS3U_COLUMNS'
export const SET_HRESS3U_LABELS = 'SET_HRESS3U_LABELS'
export const GET_HRESS3U_LABELS = 'GET_HRESS3U_LABELS'
export const RECEIVED_HRESS3U_COLUMNS_LABELS = 'RECEIVED_HRESS3U_COLUMNS_LABELS'
export const SET_HRESS3U_INDEX = 'SET_HRESS3U_INDEX'
export const GET_HRESS3U_INDEX = 'GET_HRESS3U_INDEX'
export const RECEIVED_HRESS3U_INDEX = 'RECEIVED_HRESS3U_INDEX'
export const SET_HRESS3U_INDEX_SELECTED = 'SET_HRESS3U_INDEX_SELECTED'
export const GET_HRESS3U_INDEX_SELECTED = 'GET_HRESS3U_INDEX_SELECTED'
export const SET_HRESS3U_DETAIL = 'SET_HRESS3U_DETAIL'
export const GET_HRESS3U_DETAIL = 'GET_HRESS3U_DETAIL'
export const RECEIVED_HRESS3U_DETAIL = 'RECEIVED_HRESS3U_DETAIL'
export const TOGGLE_HRESS3U_PAGE = 'TOGGLE_HRESS3U_PAGE'
export const POST_HRESS3U_SEND_APPROVE = 'POST_HRESS3U_SEND_APPROVE'

export const SET_HRESS3U_DETAIL_SUBMIT = 'SET_HRESS3U_DETAIL_SUBMIT'
export const GET_HRESS3U_DETAIL_SUBMIT = 'GET_HRESS3U_DETAIL_SUBMIT'
export const RECEIVED_HRESS3U_DETAIL_SUBMIT = 'RECEIVED_HRESS3U_DETAIL_SUBMIT'



// WEBPACK FOOTER //
// ./src/store/modules/hress3u/mutation-types.js